import React from 'react'
import about from '../Images/about.jpg'
import "./About.css"
import { Link } from 'react-router-dom'
import { motion} from 'framer-motion'

function About() {
  return (
    <>
        <div className='about mt-3' style={{height:"auto"}}>
            <div className='row'>
                <div className='col-lg-2 col-1'></div>
                <motion.div className='col-lg-4 col-10 d-flex flex-column justify-content-center mt-5'
                    variants={{
                        hidden:{opacity:0,},
                        visible:{opacity:1}
                    }}
                    initial="hidden"
                    animate="visible"
                    transition={{duration:2,delay:0}}
                >
                    <h2 className='mb-5' style={{color:"#C7C7C7"}}>About <span style={{color:"#290A0A"}}>us</span></h2>
                    <p style={{color:"#C7C7C7"}}>
                        
                        B Sharp Music School is a leading provider of music education for students of all ages and levels,
                        from beginners to advanced musicians. We offer a wide range of programs in piano and western vocals.
                        
                    </p>
                    <p style={{color:"#C7C7C7"}}>
                        
                        Our mission is to inspire, educate, and foster cultural awareness through music. 
                        We believe that music is a gift that should be shared with everyone, 
                        and we are committed to providing our students with a high-quality music education 
                        that will help them reach their full potential.
                        
                    </p>
                    <p style={{color:"#C7C7C7"}}>
                        
                        B Sharp Music School is more than just a place to learn music. 
                        It is a community where students of all ages and backgrounds come together to share their love of music. 
                        We believe that music has the power to bring people together and make the world a better place.
                    
                    </p>
                    <p style={{color:"#C7C7C7"}}>
                        
                        We invite you to join our community and experience the joy of music at B Sharp Music School!
                        
                    </p>
                </motion.div>
                <motion.div className='col-lg-6 col-12 d-flex justify-content-center mt-5 aboutpicdiv'
                    variants={{
                        hidden:{opacity:0,y:100},
                        visible:{opacity:1,y:0}
                    }}
                    initial="hidden"
                    animate="visible"
                    transition={{duration:2,delay:0}}
                >
                    <img src={about} alt='aboutpic' className='aboutpic'></img>
                </motion.div>
                <div className='col-1'></div>
            </div>
            <motion.div className='courses' id='courses'
                variants={{
                    hidden:{opacity:0},
                    visible:{opacity:1}
                }}
                initial="hidden"
                animate="visible"
                transition={{duration:2.5,delay:0}}
            >
            <h3 className='d-flex justify-content-center' style={{color:"#C7C7C7",marginTop:"200px"}}>Our Courses</h3>
            <div className='row mt-5' style={{height:"auto"}}>
                <div className='col-lg-2 col-1'></div>
                <div className='col-lg-3 col-7 d-flex flex-column'>
                    <h4 className='d-flex justify-content-center' style={{color:"#C7C7C7"}}>Piano</h4>
                    <div className='mt-3'>
                        <ul>
                            <li style={{color:"#C7C7C7"}}>
                            Music theory: Learn the basics of music theory, such as rhythm, pitch, and harmony.
                            </li>
                            <li style={{color:"#C7C7C7"}}>
                            Keyboard techniques: Learn how to play the keyboard with proper technique, including fingering, hand position, and posture.
                            </li>
                            <li style={{color:"#C7C7C7"}}>
                            Improvisation: Learn to improvise and create your own music.
                            </li>
                            <li style={{color:"#C7C7C7"}}>
                            Our instructors are highly experienced and qualified musicians.
                            </li>
                            <li style={{color:"#C7C7C7"}}>
                            We offer a variety of teaching methods to suit your individual learning style.
                            </li>
                            <li style={{color:"#C7C7C7"}}>
                            Fees -1200/- &#91;4 classes per month &#93;
                            </li>
                        </ul>
                    </div>
                    <Link to="/Registration" className='d-flex justify-content-center text-decoration-none'>
                    <button className='btn btn-light mt-3 mb-5 rounded-pill'>Register</button>
                    </Link>
                </div>
                <div className='col-lg-2'></div>
                <div className='col-lg-3 col-7 ms-4 d-flex flex-column'>
                    <h4 className='d-flex justify-content-center' style={{color:"#C7C7C7"}}>Western Vocals</h4>
                    <div className='mt-3'>
                        <ul>
                            <li style={{color:"#C7C7C7"}}>
                            Vocal technique: Learn how to sing with proper breath support, tone, and projection.
                            </li>
                            <li style={{color:"#C7C7C7"}}>
                            Performance skills: Get tips on how to deliver a powerful and engaging performance.
                            </li>
                            <li style={{color:"#C7C7C7"}}>
                            Repertoire: Learn to sing a variety of songs in different genres.
                            </li>
                            <li style={{color:"#C7C7C7"}}>
                            We offer personalized coaching to help you reach your full potential.
                            </li>
                            <li style={{color:"#C7C7C7"}}>
                            Performance skills: Get tips on how to deliver a powerful and engaging performance.
                            </li>
                            <li style={{color:"#C7C7C7"}}>
                            Fees -1200/- &#91;4 classes per month &#93;
                            </li>
                        </ul>
                    </div>
                    <Link to="/Registration" className='d-flex justify-content-center text-decoration-none'>
                    <button className='btn btn-light mt-3 mb-5 rounded-pill'>Register</button>
                    </Link>
                </div>
                <div className='col-lg-2 col-1'></div>
            </div>
            </motion.div>
        </div>
    </>
  )
}

export default About